import Vue from 'vue'
import MbwayScriptTag from './tags/scripts/mbway'
import CopyAndPayScriptTag from './tags/scripts/copy_and_pay'
import RedsysScriptTag from './tags/scripts/redsys'
import PaystoreScriptTag from './tags/scripts/paystore'

import template from './index.pug'

export default Vue.extend({
  template: template(),

  components: {PaystoreScriptTag, MbwayScriptTag, CopyAndPayScriptTag, RedsysScriptTag},

  props: {
    scriptAttrs: {
      type: Object
    },
    formAttrs: {
      type: Object
    }
  },
  methods: {
    back() {
      this.$emit('back')
    }
  }
})
